import type { ReactNode } from 'react';
import OktaBase from 'creative-ui/oktaComponents/OktaBase';

export interface OktaScreenShellProps {
  children: ReactNode;
}

/**
 * Shared screen chrome for creative-ui screens, so `OktaBase newLogo
 * backgroundColor="ultramarine"` doesn't need to be repeated in every screen.
 *
 * Do NOT use this on screens still rendering Engie's `AuthCard` (e.g.
 * signup-id, signup-password, reset-password-request) — `AuthCard` renders
 * its own full-page chrome and would be double-wrapped.
 */
export function OktaScreenShell({ children }: Readonly<OktaScreenShellProps>) {
  return (
    <OktaBase contentWidth="l" newLogo backgroundColor="ultramarine">
      {children}
    </OktaBase>
  );
}

export default OktaScreenShell;
